export default __webpack_public_path__ + "static/media/icon-pinterest.5b02655f.svg";